"use strict";
const options = {
  collectionsLoadMore: ".collections-load-more",
  blsLinkFilter: ".bls__link-filter",
  openFilter: ".filter-title .open-children-toggle",
  rangeSlider: ".price-range .range-slider",
  minPriceRange: ".min-price-range",
  maxPriceRange: ".max-price-range",
  rangeSliderMin: ".range-slider-min",
  rangeSliderMax: ".range-slider-max",
  gridMode: ".grid-mode-show-type-products .grid-mode",
  viewMode: ".view-mode",
  sidebarClose: ".sidebar-close",
  collectionSidebar: "#CollectionSidebar",
  collectionFiltersForm: "#CollectionFiltersForm",
  btnFilter: ".collection-filter .btn-filter",
  section: ".section-collection-product",
  toolbarSorter: ".toolbar-sorter .select-selected",
  facetFiltersSort: ".facet-filters__sort li",
  overlay: ".bls__overlay",
  filterSortMb: ".toolbar-sorter-mb .facet-filters__label",
  dataSortMb: ".toolbar-sorter-mb__option",
  closeSortMb: ".close-select",
};

var BlsEventCollectionShopify = (function () {
  return {
    init: function () {
      this.setupEventListeners();
      this.eventLoadMore();
      this.priceRange();
      this.actionDesc();
    },

    actionDesc: function () {
      const viewMore = document.querySelector("[data-view-more]");
      if (viewMore) {
        viewMore.addEventListener("click", function (e) {
          const target = e.currentTarget;
          if (
            target
              .closest(".heading-description")
              .classList.contains("show-full-desc")
          ) {
            target
              .closest(".heading-description")
              .classList.remove("show-full-desc");
            target.textContent = target.dataset.readMore;
          } else {
            target
              .closest(".heading-description")
              .classList.add("show-full-desc");
            target.textContent = target.dataset.readLess;
          }
        });
      }
    },

    setupEventListeners: function () {
      document.querySelectorAll(options.btnFilter).forEach((btn) => {
        btn.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (
              document
                .querySelector(options.collectionSidebar)
                .classList.contains("bls__opend-popup")
            ) {
              target.classList.remove("actived");
              document
                .querySelector(options.collectionSidebar)
                .classList.remove("bls__opend-popup");
              document
                .querySelector(options.overlay)
                .classList.add("d-none-overlay");
              document.documentElement.classList.remove("hside_opened");
              if (
                target
                  .closest(".collection-filter")
                  .classList.contains("dropdonw_sidebar")
              ) {
                if (window.innerWidth >= 1024) {
                  slideAnime({
                    target: target
                      .closest("#productgridcontainer")
                      .querySelector("#CollectionSidebar"),
                    animeType: "slideToggle",
                  });
                }
              }
              target.classList.remove("actived");
            } else {
              target.classList.add("actived");
              document
                .querySelector(options.collectionSidebar)
                .classList.add("bls__opend-popup");
              if (
                !target
                  .closest(".collection-filter")
                  .classList.contains("dropdonw_sidebar")
              ) {
                document
                  .querySelector(options.overlay)
                  .classList.remove("d-none-overlay");
                document.documentElement.classList.add("hside_opened");
              } else {
                if (window.innerWidth < 1024) {
                  document
                    .querySelector(options.overlay)
                    .classList.remove("d-none-overlay");
                  document.documentElement.classList.add("hside_opened");
                } else {
                  slideAnime({
                    target: target
                      .closest("#productgridcontainer")
                      .querySelector("#CollectionSidebar"),
                    animeType: "slideToggle",
                  });
                }
              }
            }
          },
          false
        );
      });

      document.querySelectorAll(options.openFilter).forEach((btn) => {
        btn.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            slideAnime({
              target: target
                .closest(".filter-item")
                .querySelector(".filter-content"),
              animeType: "slideToggle",
            });
            if (target.classList.contains("active")) {
              target.classList.remove("active");
            } else {
              target.classList.add("active");
            }
          },
          false
        );
      });

      document.querySelectorAll(options.sidebarClose).forEach((btn) => {
        btn.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            document
              .querySelector(options.collectionSidebar)
              .classList.remove("bls__opend-popup");
            if (document.querySelector(options.btnFilter)) {
              document
                .querySelector(options.btnFilter)
                .classList.remove("actived");
            }
            document
              .querySelector(options.overlay)
              .classList.add("d-none-overlay");
            document.documentElement.classList.remove("hside_opened");
          },
          false
        );
      });

      document.querySelectorAll(options.viewMode).forEach((view) => {
        view.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            const view_mode = target.getAttribute("data-view");
            if (target.classList.contains("actived")) return;

            const params = new URLSearchParams(window.location.search);

            params.set("view", view_mode);
            params.delete("page");

            const searchParams = params.toString();
            const url = this.renderUrl(searchParams);

            this.renderSectionFilter(url, searchParams);
          },
          false
        );
      });

      document.querySelectorAll(options.gridMode).forEach((btn) => {
        btn.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            const view_mode = target.getAttribute("data-grid-mode");
            if (target.classList.contains("actived")) return;
            if (view_mode == 1) return;
            for (var item of document.querySelectorAll(options.gridMode)) {
              item.classList.remove("actived");
            }
            const container_switch = document.querySelector(
              ".container-products-switch"
            );
            target.classList.add("actived");
            const data_view_mode =
              container_switch.getAttribute("data-view-mode");
            container_switch.classList.remove("grid-columns-" + data_view_mode);
            container_switch.setAttribute("data-view-mode", view_mode);
            container_switch.classList.add("grid-columns-" + view_mode);
          },
          false
        );
      });

      document.querySelectorAll(options.blsLinkFilter).forEach((btn) => {
        btn.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (target.querySelector(".bls_tooltip")) {
              target
                .querySelector(".bls_tooltip")
                .classList.toggle("current-filter");
            } else {
              target.closest("li").classList.toggle("current-filter");
            }
            const url = target.getAttribute("href");
            this.renderSectionFilter(url);
          },
          false
        );
      });

      document.body.addEventListener("click", (evt) => {
        const target = evt.target;
        const btn_dropdonw_sidebar = document.querySelector(
          ".collection-filter.dropdonw_sidebar .btn-filter"
        );
        if (
          !target.closest(".select-custom") &&
          target != document.querySelector(".toolbar-sorter .select-custom")
        ) {
          if (document.querySelector(".toolbar-sorter .select-custom")) {
            document
              .querySelector(".toolbar-sorter .select-custom")
              .classList.remove("actived");
          }
        }
        if (
          !target.closest("#CollectionSidebar") &&
          target != document.querySelector("#CollectionSidebar") &&
          btn_dropdonw_sidebar &&
          target != btn_dropdonw_sidebar
        ) {
          if (window.innerWidth >= 1024) {
            btn_dropdonw_sidebar.classList.remove("actived");
            document
              .querySelector(options.collectionSidebar)
              .classList.remove("bls__opend-popup");
            document
              .querySelector(options.overlay)
              .classList.add("d-none-overlay");
            document.documentElement.classList.remove("hside_opened");
            slideAnime({
              target: btn_dropdonw_sidebar
                .closest("#productgridcontainer")
                .querySelector("#CollectionSidebar"),
              animeType: "slideUp",
            });
          }
        }
      });

      document.querySelectorAll(options.toolbarSorter).forEach((filterSort) => {
        filterSort.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (
              target.closest(".select-custom").classList.contains("actived")
            ) {
              target.closest(".select-custom").classList.remove("actived");
            } else {
              target.closest(".select-custom").classList.add("actived");
            }
          },
          false
        );
      });

      if (document.querySelector(options.filterSortMb)) {
        document.querySelector(options.filterSortMb).addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            if (
              target
                .closest(".toolbar-sorter-mb")
                .classList.contains("open-selected")
            ) {
              target
                .closest(".toolbar-sorter-mb")
                .classList.remove("open-selected");
            } else {
              target
                .closest(".toolbar-sorter-mb")
                .classList.add("open-selected");
            }
          },
          false
        );
      }

      if (document.querySelector(options.closeSortMb)) {
        document
          .querySelector(options.closeSortMb)
          .addEventListener("click", (event) => {
            event.preventDefault();
            document
              .querySelector(".toolbar-sorter-mb")
              .classList.remove("open-selected");
          });
      }

      document
        .querySelectorAll(options.facetFiltersSort)
        .forEach((filterSort) => {
          filterSort.addEventListener(
            "click",
            (event) => {
              event.preventDefault();
              const target = event.currentTarget;
              const value = target.getAttribute("value");
              var queryString = window.location.search;
              queryString = this.removeParam("sort_by", queryString);
              var searchParams =
                queryString.replace("?", "") + "&sort_by=" + value;
              const url = this.renderUrl(searchParams);
              this.renderSectionFilter(url, searchParams);
            },
            false
          );
        });
    },

priceRange: function () {
  const form = document.querySelector("#CollectionFiltersForm");
  if (!form) return;

  const minPrice = form.querySelector(".min-price-range");
  const maxPrice = form.querySelector(".max-price-range");
  const priceRange = form.querySelector("price-range");

  if (!minPrice || !maxPrice || !priceRange) return;

  const rangeMax = Number(form.dataset.priceRangeMax) || 0;

  const formatPrice = (value) => {
    const digits = String(value ?? "").replace(/\D/g, "");
    if (!digits) return "";
    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const parsePrice = (value) => {
    const digits = String(value ?? "").replace(/\D/g, "");
    return digits ? Number(digits) : 0;
  };

  const formatInput = (input) => {
    const oldValue = input.value;
    const oldCaret = input.selectionStart ?? oldValue.length;

    const digitsBeforeCaret = oldValue
      .slice(0, oldCaret)
      .replace(/\D/g, "").length;

    const formatted = formatPrice(oldValue);

    input.value = formatted;

    let newCaret = 0;
    let digitCount = 0;

    while (
      newCaret < formatted.length &&
      digitCount < digitsBeforeCaret
    ) {
      if (/\d/.test(formatted[newCaret])) {
        digitCount++;
      }
      newCaret++;
    }

    try {
      input.setSelectionRange(newCaret, newCaret);
    } catch (e) {}
  };

  const getValidValues = () => {
    let minValue = parsePrice(minPrice.value);
    let maxValue = parsePrice(maxPrice.value);

    if (rangeMax > 0) {
      minValue = Math.min(minValue, rangeMax);
      maxValue = Math.min(maxValue, rangeMax);
    }

    minValue = Math.max(minValue, 0);
    maxValue = Math.max(maxValue, 0);

    // Min không được lớn hơn hoặc bằng Max
    if (minValue >= maxValue) {
      if (rangeMax > 0 && minValue < rangeMax) {
        maxValue = minValue + 1;
      } else {
        minValue = Math.max(0, maxValue - 1);
      }
    }

    return {
      min: minValue,
      max: maxValue,
    };
  };

  const applyPriceFilter = () => {
    const values = getValidValues();

    minPrice.value = formatPrice(values.min);
    maxPrice.value = formatPrice(values.max);

    /*
     * Tạm thời đưa giá trị về dạng số nguyên để FormData
     * gửi đúng giá trị cho Shopify.
     */
    const formattedMin = minPrice.value;
    const formattedMax = maxPrice.value;

    minPrice.value = values.min;
    maxPrice.value = values.max;

    const formData = new FormData(form);
    const params = new URLSearchParams(formData).toString();

    minPrice.value = formattedMin;
    maxPrice.value = formattedMax;

    const nameMin = minPrice.getAttribute("name");
    const nameMax = maxPrice.getAttribute("name");

    let queryString = window.location.search;

    queryString = this.removeParam(nameMin, queryString);
    queryString = this.removeParam(nameMax, queryString);

    const oldParams = queryString.replace("?", "");

    const searchParams = oldParams
      ? oldParams + "&" + params
      : params;

    const url = this.renderUrl(searchParams);

    this.renderSectionFilter(url, searchParams);
  };

  /*
   * Format ngay khi filter được render.
   * Vì Shopify trả giá trị dạng số nên người dùng luôn thấy:
   * 9300000000 -> 9.300.000.000
   */
  minPrice.value = formatPrice(minPrice.value);
  maxPrice.value = formatPrice(maxPrice.value);

  let originalMin = parsePrice(minPrice.value);
  let originalMax = parsePrice(maxPrice.value);

  /*
   * Format số trong lúc nhập nhưng KHÔNG gọi AJAX.
   */
  [minPrice, maxPrice].forEach((input) => {
    input.addEventListener("input", function () {
      formatInput(this);
    });

    /*
     * Vẫn giữ hành vi click/tap để chọn toàn bộ giá trị
     * thông qua onclick="this.select()" trong Liquid.
     */
    input.addEventListener("focus", function () {
      this.dataset.originalValue = String(parsePrice(this.value));
    });

    /*
     * Xử lý Backspace/Delete khi con trỏ đứng cạnh dấu ".".
     * Cho phép xóa số tự nhiên mà không bị dấu chấm cản trở.
     */
    input.addEventListener("keydown", function (event) {
      const start = this.selectionStart;
      const end = this.selectionEnd;

      if (start !== end) return;

      if (event.key === "Backspace" && start > 0) {
        if (this.value[start - 1] === ".") {
          event.preventDefault();

          this.setSelectionRange(start - 2, start);
          document.execCommand("delete");

          formatInput(this);
        }
      }

      if (event.key === "Delete" && start < this.value.length) {
        if (this.value[start] === ".") {
          event.preventDefault();

          this.setSelectionRange(start, start + 2);
          document.execCommand("delete");

          formatInput(this);
        }
      }

      /*
       * Enter = áp dụng ngay.
       */
      if (event.key === "Enter") {
        event.preventDefault();

        const activeElement = document.activeElement;

        if (activeElement === minPrice || activeElement === maxPrice) {
          activeElement.blur();
        }
      }
    });
  });

  /*
   * QUAN TRỌNG:
   *
   * Không apply khi Min blur nếu người dùng chỉ đang
   * chuyển từ Min sang Max.
   *
   * Chỉ apply khi focus đã rời khỏi TOÀN BỘ price-range.
   */
  priceRange.addEventListener("focusout", () => {
    setTimeout(() => {
      /*
       * Người dùng vẫn đang ở trong cụm Min/Max.
       * Ví dụ:
       *
       * Min -> Max
       *
       * => Không AJAX.
       */
      if (priceRange.contains(document.activeElement)) {
        return;
      }

      const currentMin = parsePrice(minPrice.value);
      const currentMax = parsePrice(maxPrice.value);

      /*
       * Không thay đổi gì => không AJAX.
       */
      if (
        currentMin === originalMin &&
        currentMax === originalMax
      ) {
        return;
      }

      applyPriceFilter();
    }, 0);
  });
},
    
    removeParam: function (key, sourceURL) {
      var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString =
          sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";
      if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
            params_arr.splice(i, 1);
          }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
      }
      return rtn;
    },

    renderUrl: function (searchParams) {
      const sectionId = document.querySelector(options.section).dataset
        .sectionId;
      const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
      return url;
    },

    renderSectionFilter: function (url, searchParams) {
  const filterSidebar = document.querySelector(options.collectionSidebar);
  const filterWasOpen =
    filterSidebar?.classList.contains("bls__opend-popup");

  this.toggleLoading(document.body, true);

  fetch(`${url}`)
    .then((response) => {
      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      return response.text();
    })
    .then((responseText) => {
      const newSection = new DOMParser()
        .parseFromString(responseText, "text/html")
        .querySelector(options.section);

      document.querySelector(options.section).replaceWith(newSection);

      if (typeof vmsApplyPaginationPreferences === "function") {
        vmsApplyPaginationPreferences();
      }

      if (filterWasOpen) {
        const newFilterSidebar = document.querySelector(
          options.collectionSidebar
        );

        if (newFilterSidebar) {
          newFilterSidebar.classList.add("bls__opend-popup");
        }

        const overlay = document.querySelector(options.overlay);

        if (overlay) {
          overlay.classList.remove("d-none-overlay");
        }

        document.documentElement.classList.add("hside_opened");
      }

      this.toggleLoading(document.body, false);
    })
    .catch((error) => {
      throw error;
    })
    .finally(() => {
      BlsReloadSpr.init();
      BlsEventCollectionShopify.init();
      BlsColorSwatchesShopify.init();
      BlsSubActionProduct.init();

      setTimeout(function () {
        BlsLazyloadImg.init();
      }, 200);
    });

  this.updateUrl(url, searchParams);
},

    eventLoadMore: function () {
      document
        .querySelectorAll(options.collectionsLoadMore)
        .forEach((loadMore) => {
          var _this = this;
          if (loadMore.classList.contains("infinit-scrolling")) {
            var observer = new IntersectionObserver(
              function (entries) {
                entries.forEach((entry) => {
                  entries.forEach((entry) => {
                    if (entry.intersectionRatio === 1) {
                      _this.loadMoreProducts(loadMore);
                    }
                  });
                });
              },
              { threshold: 1.0 }
            );
            observer.observe(loadMore);
          } else {
            loadMore.addEventListener(
              "click",
              (event) => {
                event.preventDefault();
                const target = event.currentTarget;
                _this.loadMoreProducts(target);
              },
              false
            );
          }
        });
    },

    loadMoreProducts: function (target) {
      const loadMore_url = target.getAttribute("href");
      this.toggleLoading(target, true);
      fetch(`${loadMore_url}`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            throw error;
          }
          return response.text();
        })
        .then((responseText) => {
          const productNodes = parser.parseFromString(
            responseText,
            "text/html"
          );
          const productNodesHtml = productNodes.querySelectorAll(
            "#bls__product-grid .bls__grid__item"
          );
          const grid = document.getElementById("bls__product-grid");
          if (grid) {
            productNodesHtml.forEach((prodNode) => grid.appendChild(prodNode));
          }
          const load_more = productNodes.querySelector(
            ".collections-load-more"
          );
          const amountEl = document.querySelector(".load-more-amount");
const percentEl = document.querySelector(".load-more-percent");
if (amountEl && productNodes.querySelector(".load-more-amount")) {
  amountEl.innerHTML = productNodes.querySelector(".load-more-amount").textContent;
}
if (percentEl && productNodes.querySelector(".load-more-percent")) {
  percentEl.style.width = productNodes.querySelector(".load-more-percent").style.width;
}
          if (load_more) {
            target.setAttribute("href", load_more.getAttribute("href"));
          } else {
            target.remove();
          }
          this.toggleLoading(target, false);
        })
        .catch((error) => {
          throw error;
        })
        .finally(() => {
          BlsColorSwatchesShopify.init();
          BlsSubActionProduct.init();
          BlsReloadSpr.init();
          setTimeout(function () {
            BlsLazyloadImg.init();
          }, 200);
        });
    },

    toggleLoading: function (event, loading) {
      if (event) {
        if (loading) {
          event.classList.add("start", "loading");
        } else {
          event.classList.add("finish");
          setTimeout(function () {
            event.classList.remove("start", "loading", "finish");
          }, 500);
        }
      }
    },

    updateUrl: function (url, searchParams = false) {
      if (searchParams) {
        const urlUpdate = `${window.location.pathname}?${searchParams}`;
        window.history.pushState({ url: urlUpdate }, "", urlUpdate);
      } else {
        window.history.pushState({ url: url }, "", url);
      }
    },
  };
})();
BlsEventCollectionShopify.init();
